// "aaaa-mm-gg" o ISO datetime -> "gg/mm/aaaa"; altri valori invariati
export const fmtIT = (v, vuoto = "—") => {
  if (!v) return vuoto;
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : v;
};
